import { twMerge } from 'tailwind-merge'
import { GifAttachment } from 'modules/community/types/post-attachment'

interface GifAttachmentPreviewProps {
  className?: string
  attachment: GifAttachment
}

export const GifAttachmentPreview = ({ attachment, className }: GifAttachmentPreviewProps) => (
  <div
    className={twMerge(
      'size-full overflow-hidden rounded-lg',
      !attachment.previewUrl && 'bg-background-primary',
      className,
    )}
  >
    {!!attachment.previewUrl && (
      <img
        src={attachment.previewUrl}
        alt=""
        className="size-full object-cover transition-all group-hover:scale-110"
      />
    )}
  </div>
)
